import { createSlice } from '@reduxjs/toolkit';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import FeaturesAPI from '~/api/features-api';
import { defaultState } from './data/FeaturesState';

export const getFeatureActive = createCaughtAsyncThunk<
  boolean,
  { featureName: string }
>(
  'getFeatureActive',
  async (args) => await FeaturesAPI.getFeatureActive(args.featureName)
);

const slice = createSlice({
  name: 'feature-active',
  initialState: defaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeatureActive.pending, (state, action) => {
      state.features[action.meta.arg.featureName] = {
        isLoading: true,
        feature: action.meta.arg.featureName,
        isActive: false,
      };
    });

    builder.addCase(getFeatureActive.fulfilled, (state, action) => {
      state.features[action.meta.arg.featureName].isLoading = false;
      state.features[action.meta.arg.featureName].isActive = action.payload;
    });

    builder.addCase(getFeatureActive.rejected, (state, action) => {
      state.features[action.meta.arg.featureName].isLoading = false;
      state.features[action.meta.arg.featureName].isActive = false;
    });
  },
});

export default slice.reducer;
